/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDocumentRejectionReasonsFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type DocumentRejectionReasons, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /documents/rejection-reasons
 */
export interface RejectionReasonsRequestBuilder extends BaseRequestBuilder<RejectionReasonsRequestBuilder> {
    /**
     * GetDocumentRejectionReasons
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DocumentRejectionReasons[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DocumentRejectionReasons[] | undefined>;
    /**
     * GetDocumentRejectionReasons
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RejectionReasonsRequestBuilderUriTemplate = "{+baseurl}/documents/rejection-reasons";
/**
 * Metadata for all the requests in the request builder.
 */
export const RejectionReasonsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RejectionReasonsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDocumentRejectionReasonsFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
